import _styled from "@emotion/styled/base";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { IconExpandMore } from '@travel-frontend/icons';
import { useEffect, forwardRef, useCallback, useState } from 'react';
import { CountrySelector, defaultCountries, usePhoneInput } from 'react-international-phone';
import { Message } from '../../primitives/internal/Message/index.js';
import { CountrySelectorButtonWrapper } from '../../primitives/TextInput/components/CountrySelectorButtonWrapper.js';
import { Input } from '../../primitives/TextInput/components/Input.js';
import { Label } from '../../primitives/TextInput/components/Label.js';
import { PhoneInputContainer } from '../../primitives/TextInput/components/PhoneInputContainer.js';
import { PhonePrefixContainer } from '../../primitives/TextInput/components/PrefixContainer.js';
import { Wrapper } from '../../primitives/TextInput/components/Wrapper.js';
import 'react-international-phone/style.css';
export const PhoneField = /*#__PURE__*/_styled(forwardRef(function Field({
  id,
  label,
  message,
  name,
  value,
  disabled,
  invalid,
  fullWidth,
  visuallyFocused,
  className,
  onFocus,
  onBlur,
  size = 'medium',
  variant = 'info',
  allowOverflow,
  type = 'text',
  inputRef: inputRefFromProps = null,
  defaultCountry = 'de',
  onSelectedCountryCodeChange,
  selectedCountry,
  ...restProps
}, ref) {
  const [focused, setFocused] = useState(false);
  const {
    inputValue: phonePrefix,
    inputRef: inputRefPhone,
    country,
    setCountry
  } = usePhoneInput({
    defaultCountry: defaultCountry,
    value: ''
  });
  const priorityOrder = ['Deutschland', 'Schweiz', 'Österreich'];
  const regionNamesInGerman = new Intl.DisplayNames(['de'], {
    type: 'region'
  });
  const translatedAndSortedCountries = defaultCountries.map(([countryName, iso2, ...rest]) => {
    const countryNameInGerman = regionNamesInGerman.of(iso2.toUpperCase()) || countryName;
    return [countryNameInGerman, iso2, ...rest];
  }).toSorted((a, b) => {
    const aIndex = priorityOrder.indexOf(a[0]);
    const bIndex = priorityOrder.indexOf(b[0]);
    const aIsPriority = aIndex !== -1;
    const bIsPriority = bIndex !== -1;
    if (aIsPriority && bIsPriority) {
      return aIndex - bIndex;
    }
    if (aIsPriority) return -1;
    if (bIsPriority) return 1;
    return a[0].localeCompare(b[0]);
  });
  const inputRef = inputRefFromProps || inputRefPhone;
  const handleFocus = useCallback(event => {
    if (onFocus) {
      onFocus(event);
    }
    setFocused(true);
  }, [onFocus]);
  const handleBlur = useCallback(event => {
    if (onBlur) {
      onBlur(event);
    }
    setFocused(false);
  }, [onBlur]);
  const hiddenElementStyle = {
    display: 'none'
  };
  useEffect(() => {
    if (phonePrefix) onSelectedCountryCodeChange?.(phonePrefix);
  }, [phonePrefix]);
  useEffect(() => {
    if (selectedCountry && selectedCountry !== country.iso2) {
      setCountry(selectedCountry);
    }
  }, [selectedCountry]);
  return _jsxs(Wrapper, {
    fullWidth: fullWidth,
    ref: ref,
    children: [_jsxs(PhoneInputContainer, {
      className: className,
      invalid: invalid,
      disabled: disabled,
      // @ts-expect-error TS(2322) FIXME: Type 'boolean | undefined' is not assignable to ty... Remove this comment to see the full error message
      focused: focused || visuallyFocused,
      variant: variant,
      children: [_jsx(CountrySelector, {
        countries: translatedAndSortedCountries,
        selectedCountry: country.iso2,
        dropdownArrowStyle: hiddenElementStyle,
        dropdownStyleProps: {
          listItemFlagStyle: hiddenElementStyle,
          listItemDialCodeStyle: hiddenElementStyle
        },
        renderButtonWrapper: ({
          children,
          rootProps
        }) => {
          const {
            onClick,
            ...restRootProps
          } = rootProps;
          return _jsxs(CountrySelectorButtonWrapper, {
            tabIndex: 0,
            onClick: e => {
              e.preventDefault();
              onClick();
            },
            rotate: !!rootProps['aria-expanded'],
            ...restRootProps,
            children: [children, _jsx(IconExpandMore, {
              color: 'interactionSecondary'
            })]
          });
        },
        onSelect: parsedCountry => {
          setCountry(parsedCountry.iso2);
        }
      }), _jsx(PhonePrefixContainer, {
        children: phonePrefix
      }), _jsx(Input
      // @ts-expect-error (TS2322) FIXME: Type RefObject<HTMLInputElement | null> is not assignable to type Ref<HTMLInputElement> | undefined>
      , {
        // @ts-expect-error (TS2322) FIXME: Type RefObject<HTMLInputElement | null> is not assignable to type Ref<HTMLInputElement> | undefined>
        ref: inputRef,
        id: id,
        allowOverflow: allowOverflow,
        disabled: disabled,
        name: name,
        value: value,
        size: size,
        onFocus: handleFocus,
        onBlur: handleBlur,
        type: type,
        "aria-label": label,
        ...restProps
      }), _jsx(Label, {
        tabIndex: -1,
        "data-testid": "label",
        disabled: disabled,
        htmlFor: id,
        children: label
      })]
    }), message && _jsx(Message, {
      "data-testid": "message",
      invalid: invalid,
      children: message
    })]
  });
}), process.env.NODE_ENV === "production" ? {
  target: "e1gjsbt70"
} : {
  target: "e1gjsbt70",
  label: "PhoneField"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");